document.querySelectorAll(".dropdown-menu").forEach((details) => {
    const summary = details.querySelector(".header__menu-item");
    const span = summary.querySelector("span");

    details.setAttribute("open", ""); 
    details.addEventListener("toggle", function (event) {
        if (!details.open) {
            details.setAttribute("open", "");
        }
    });

    summary.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
    });

    details.addEventListener("click", function (event) {
        if (event.target === details || event.target === summary || event.target === span) {
            event.preventDefault();
            event.stopPropagation();
        }
    });

    const links = details.querySelectorAll(".header__submenu a");
    links.forEach((link) => {
        link.addEventListener("click", function (event) {
            event.stopPropagation();
        });
    });
});

document.querySelectorAll("header-menu").forEach((menu) => {
 menu.addEventListener("click", function (event) {
  event.preventDefault();
 });
});